<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: FileManager.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,   -->
<!-- propagated, or distributed without prior approval by ESA.               -->
<template>
  <div class="embed-container">
    <iframe id="myiframe" :src="fileManagerUrl" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<script>
import * as api from '@/lib/api'
export default {
  data() {
    return {
      fileManagerUrl: '',
    }
  },
  methods: {
    async openFileManager() {
      //Function definition for polling status api
      async function poll(response) {
        let data = await api.pollAssetLabStatus(response.id)
        console.log('status is', data.status, 'so waiting 1s')
        while (data.status != 'Running') {
          await wait(1000)
          data = await api.pollAssetLabStatus(response.id)
          console.log({ data })
        }
        console.log({ data })
        return data
      }
      //wait function that returns a promise
      function wait(ms = 1000) {
        return new Promise(resolve => {
          // console.log(`waiting ${ms} ms...`)
          setTimeout(resolve, ms)
        })
      }

      const response = await api.getFileManagerUrl()
      if (response) {
        console.log(response)
      }

      let data = null
      if (response) {
        //If type if response is string means error message is given
        data = await poll(response)
      }
      if (data) {
        this.$emit('finishLoading')
      }

      // console.log('filemanager url', response.url)
      if (this.$route.params.foldername) {
        //Unfortunately can't pass two subfolders to file manager
        //So we can't reach foldername for the time being
        //TODO: if File Manager is improved, remove comment
        this.fileManagerUrl = response.url // + '/Downloads/' // + this.$route.params.foldername
      } else {
        console.log(response.url)

        this.fileManagerUrl = response.url
      }
    },
    // async openFileManagerNew() {
    //   const response = await api.getFileManagerUrl()
    //   if (response) this.$emit('finishLoading')
    //   console.log('filemanager response', response)
    //   // if (this.$route.params.foldername) {
    //   //   //Unfortunately can't pass two subfolders to file manager
    //   //   //So we can't reach foldername for the time being
    //   //   //TODO: if File Manager is improved, remove comment
    //   //   this.fileManagerUrl = response.url + '/Downloads' // + this.$route.params.foldername
    //   // } else {
    //   //   this.fileManagerUrl = response.url
    //   // }
    //   const data = await api.getFileManager(response.url, response.lab_token)
    //   //var data_url = URL.createObjectURL(this.response)
    //   this.fileManagerUrl = 'about:blank' //data_url
    //   this.fileManagerUrl = 'data:text/html;charset=utf-8,' + escape(data.data)
    //   var iframe = document.getElementById('myiframe')
    //   console.log(data)
    //   iframe.contentWindow.contents = data.data
    //   this.fileManagerUrl = 'javascript:window["contents"]'
    // },
  },
  async mounted() {
    await this.openFileManager()
  },
}
</script>

<style scoped>
iframe {
  width: 100%;
  height: calc(100vh - 64px - 56px - 80px);
  border: none;
  overflow: hidden;
}

@media (max-width: 675px) {
  /* iframe {
                          height: 700px;
                        } */
}
</style>
